<script setup lang="ts">
import { ref, computed } from 'vue';
import coinSprite from '@/assets/widget/coin.png';

const props = defineProps<{
	scale?: number;
}>();

const scale = computed(() => props.scale ?? 1);

const SPRITE_SIZE = 186;
const SPRITE_SHEET_WIDTH = 1116; // 186 * 6 frames

const emit = defineEmits<{
	(event: 'animation_end'): void;
}>();

const isAnimating = ref(false);

const run = () => {
	isAnimating.value = true;
};

const cancel = () => {
	isAnimating.value = false;
};

const handleAnimationEnd = () => {
	isAnimating.value = false;
	emit('animation_end');
};

// Expose methods for parent components
defineExpose({
	run,
	cancel
});
</script>

<template>
	<div
		class="coin-sprite"
		:class="{ 'coin-animate': isAnimating }"
		:style="{
			width: `${SPRITE_SIZE}px`,
			height: `${SPRITE_SIZE}px`,
			transform: `translate(-50%, -50%) scale(${scale})`,
			backgroundSize: `${SPRITE_SHEET_WIDTH}px ${SPRITE_SIZE}px`,
			backgroundImage: `url(${coinSprite})`
		}"
		@animationend="handleAnimationEnd"
	></div>
</template>

<style scoped>
.coin-sprite {
	overflow: hidden;
	background-repeat: no-repeat;
	background-position: 0 0;
	transition: transform 0.3s ease;
	position: absolute;
	left: 50%;
	top: 50%;
	transform-origin: center;
}

.coin-animate {
	animation: coin-spin 0.6s steps(6) forwards;
}

@keyframes coin-spin {
	from {
		background-position: 0 0;
	}
	to {
		background-position: -1116px 0;
	}
}
</style>
